import { observer } from "mobx-react-lite";
import { Fragment } from "react";
import "./index.css";
import notFound from "../../assets/not_found.png";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

function NotFound() {
    const navigate = useNavigate();
  return (
    <Fragment>
      <div className="notFound">
        <div className="notFoundText">
          <img src={notFound} alt="" />
          <div className="rightText">
            <div className="text1">404</div>
            <div className="reason">抱歉，你访问的页面不存在</div>
            <div>
              <Button type="primary" onClick={()=>{navigate('/home')}}>返回首页</Button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default observer(NotFound);
